<template>
  <div>
    <div class="app-content content">
      <div class="content-wrapper">
        <div class="content-wrapper-before"></div>
        <div class="content-header row"></div>
        <router-view/>
      </div>
    </div>
  </div>
</template>

<style>
body.auth-layout {
  background-color: #77d1f3 !important;
}
</style>

<script>
export default {
  mounted: function () {
    $('body')
      .removeClass('menu-expanded vertical-overlay-menu menu-open menu-hide')
      .addClass('auth-layout')
  },
  beforeDestroy: function () {
    $('body').removeClass('auth-layout')
  }
}
</script>
